// extracted by mini-css-extract-plugin
module.exports = {"Button":"PrimaryButton_Button__2WDgG"};